<template>
  <div class="box-content flex w-full h-32 overflow-hidden text-xs bg-white rounded shadow-md md:w-72 text-primary-900">
    <div class="shrink-0">
      <slot v-if="contentfulFileUrl" name="image">
        <ContentfulImage :entry="contact.image" fit="fill" :width="100" :height="128" />
      </slot>
      <CImage v-else-if="contact.image" class="shrink-0" :src="contact.image" :width="100" :height="128" fit="cover" />
      <CImage v-else class="shrink-0" src="/contact-card-placeholder.svg" :width="100" :height="128" />
    </div>
    <div class="flex flex-col justify-between p-4 overflow-hidden">
      <h4 class="font-bold truncate">{{ contact.name }}</h4>
      <span class="mb-3 truncate">{{ contact.role }}</span>
      <div class="flex flex-col">
        <span v-if="contact.phone">
          <a :href="phoneLink">{{ contact.phone }}</a>
        </span>
        <span v-if="contact.email" class="truncate">
          <a :href="emailLink">{{ contact.email }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContactCardFields } from '@/types/contentful';

type Props = {
  contact: ContactCardFields;
};

const props = defineProps<Props>();

const contentfulFileUrl = computed(() => props.contact.image?.fields?.file?.url);
const emailLink = computed(() => `mailto:${props.contact.email}`);
const phoneLink = computed(() => `tel:${props.contact.phone}`);
</script>

<script lang="ts">
export default defineComponent({
  name: 'CustomerContactCard',
});
</script>
